import { render, staticRenderFns } from "./MeterUserinfoTransferRecordModal.vue?vue&type=template&id=a4d2639a"
import script from "./MeterUserinfoTransferRecordModal.vue?vue&type=script&lang=js"
export * from "./MeterUserinfoTransferRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports